import { render, staticRenderFns } from "./TheRightPanelAudioController.vue?vue&type=template&id=24523aa8&"
import script from "./TheRightPanelAudioController.vue?vue&type=script&lang=ts&"
export * from "./TheRightPanelAudioController.vue?vue&type=script&lang=ts&"
import style0 from "./TheRightPanelAudioController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports